<template>
  <div style="min-height: 300px" id="GridParent">
    <ejs-grid ref="SO_lineItem_Grid" :load="loadSoGrid" :enableAutoFill="true" :dataSource="data" :toolbar="toolbar"
      :editSettings="editSettings" :columns="computedColumns" :actionComplete="actionComplete"
      :commandClick="commandClick" :toolbarClick="toolbarClick" :height="screenHeight" :beforeBatchAdd="beforeBatchAdd"
      :beforeBatchSave="beforeBatchSave" :locale="locale" :cellEdit="cellEdit" :queryCellInfo="queryCellInfo"
      :cellSave="cellSave" :loadingIndicator="loadingIndicator" :beforeDataBound="beforeDataBound"
      :dataBound="dataBound" :actionBegin="actionBegin">
    </ejs-grid>
    <confirm-dialog ref="confirm" />
    <message-sheet :showMessage="displayMessage" :message="message" :messageType="messageType"
      @close="displayMessage = false"></message-sheet>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import Loader from "@/components/Loader";
import MessageSheet from "../MessageSheet.vue";
import columnTemplate from "/src/components/settings/columnTemplate.vue";
import PrimaryColumnTemplate from "/src/components/settings/PrimaryColumnTemplate.vue";
import columnEditTemplate from "/src/components/settings/columnEditTemplate.vue";
import booleanEditTemplate from "/src/components/settings/booleanEditTemplate.vue";
import gridColorSelector from "@/components/settings/gridColorSelector.vue";
import { createUUID } from "/src/utils/util";
import { TITLE_LENGTH_150 } from "@/utils/constant";
import _ from "lodash";
import { L10n } from "@syncfusion/ej2-base";
import tenantConfigService from "../../api/tenantConfigService";
import * as localeText from "@/Langs/locale.json";
L10n.load(localeText.default);

Vue.prototype.$eventHub = new Vue();
import {
  Edit,
  Toolbar,
  ColumnChooser,
  Resize,
  CommandColumn,
  Page,
} from "@syncfusion/ej2-vue-grids";
import { DEFAULT_MEETING_TYPE_COLOR } from "../../utils/constant";

export default {
  components: {
    ConfirmDialog,
    Loader,
    MessageSheet,
  },
  name: "settingGrid",
  props: {
    screenHeight: {
      type: Number,
      default: 250,
    },
    setting: {
      type: Object,
      required: true,
    },
    isChangePrevent: {
      type: Boolean,
      default: false,
    },
    isOpenPrevent: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      grid: [Edit, Toolbar, ColumnChooser, Resize, CommandColumn, Page],
    };
  },
  data() {
    return {
      isDirty: this.isChangePrevent,
      initialData: [],
      displayMessage: false,
      messageType: "",
      message: "",
      Loaderloading: false,
      data: [],
      uniqueMsg: "",
      editSettings: {
        showConfirmDialog: false,
        showDeleteConfirmDialog: false,
        allowEditing: true,
        allowAdding: true,
        allowDeleting: true,
        mode: "Batch",
        newRowPosition: "Top",
      },
      uniqueValidation: { required: [this.uniqueValidationFn] },
      genericRequiredRules: {
        required: [this.customValidationFn],
        maxLength: TITLE_LENGTH_150,
        regex: /[一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ々〆〤]/,
      },
      numberRules: {
        required: true,
        number: true,
        min: [1, this.$t("admin.validNumberGreater")],
        max: [9999, this.$t("admin.validNumberMax")],
      },
      numberRulesWithUnique: {
        required: [this.numberUniqueFn, this.$t("widget.fieldRequired")],
        number: true,
        min: [1, this.$t("admin.validNumberGreater")],
        max: [9999, this.$t("admin.validNumberMax")],
      },
      toolbar: ["Add", "Update", "Cancel"],
      SO_lineItem_Grid_Loaded: false,
      numericParams: {
        params: {
          validateDecimalOnType: true,
          decimals: 0,
          format: "N",
          min: 1,
        },
      },
      boolParams: { params: { checked: true } },
      loadingIndicator: { indicatorType: "Spinner" },
      columnTemplate: function () {
        return () => {
          return {
            template: {
              extends: columnTemplate,
              data() {
                return {
                  data: {},
                };
              },
            },
          };
        };
      },
      primaryColumnTemplate: function () {
        return () => {
          return {
            template: {
              extends: PrimaryColumnTemplate,
              propData: {},
              data() {
                return {
                  data: {
                    id: createUUID(),
                  },
                };
              },
            },
          };
        };
      },
      columnEditTemplate: function () {
        return () => {
          return {
            template: {
              extends: columnEditTemplate,
              data() {
                return {
                  data: {
                    manu: "heu",
                  },
                };
              },
              computed: {
                column: {
                  get() {
                    let field = this.data.column.field;
                    if (this.data[field]) {
                      const data = _.cloneDeep(this.data[field]);
                      if (typeof data !== "object") {
                        return this.data[field];
                      } else {
                        return "";
                      }
                    } else {
                      return "";
                    }
                  },
                  set(value) {
                    let field = this.data.column.field;
                    if (this.data && this.data[field] && value) {
                      this.data[field] = value;
                    }
                  },
                },
              },
            },
          };
        };
      },
      booleanEditTemplate: function () {
        return () => {
          return {
            template: {
              extends: booleanEditTemplate,
              data() {
                return {
                  data: {},
                };
              },
              computed: {
                column: {
                  get() {
                    let field = this.data.column.field;
                    if (this.data[field]) {
                      const data = _.cloneDeep(this.data[field]);
                      if (typeof data !== "object") {
                        return Boolean(this.data[field]);
                      } else {
                        return false;
                      }
                    } else {
                      return field === 'is_displayed_on_annual_plan' && this.data[field] === undefined ? true : false;
                    }
                  },
                  set(value) {
                    let field = this.data.column.field;
                    if (this.data && this.data[field] && value) {
                      const fieldVal = value == "on" ? true : false;
                      this.data[field] = fieldVal;
                    }
                  },
                },
              },
            },
          };
        };
      },
      colorEditTemplate: function () {
        return () => {
          return {
            template: {
              extends: gridColorSelector,
              data() {
                return {
                  data: {},
                  dialogColorPicker: false,
                  type: "hex",
                  rand: Math.floor(Math.random() * 1000000),
                };
              },
              computed: {
                selectedColor: {
                  get() {
                    let field = this.data.column.field;
                    if (this.data[field]) {
                      const data = _.cloneDeep(this.data[field]);
                      if (typeof data !== "object") {
                        return this.data[field];
                      } else {
                        return DEFAULT_MEETING_TYPE_COLOR;
                      }
                    } else {
                      return DEFAULT_MEETING_TYPE_COLOR;
                    }
                  },
                  set(value) {
                    let field = this.data.column.field;
                    if (this.data) {
                      this.data[field] = value;
                    }
                  },
                },
              },
              mounted() {
                const _this = this;
                setTimeout(function () {
                  _this.dialogColorPicker = true;
                }, 100);
              },
              methods: {
                selectColor() {
                  this.dialogColorPicker = false;

                  try {
                    const field = this.data?.column?.field;
                    const rowId = this.data?.id; 
                    const newColor = this.selectedColor;

                    let parent = this.$parent;
                    while (parent && !parent.gridInstance) {
                      parent = parent.$parent;
                    }
                    if (!parent || !parent.gridInstance || !field || !rowId) return;

                    const grid = parent.gridInstance;

                    this.data[field] = newColor;

                    try {
                      const editModule = grid.editModule;
                      if (editModule && editModule.getBatchChanges) {
                        const batch = editModule.getBatchChanges();
                        const added = batch.addedRecords || [];
                        const changed = batch.changedRecords || [];
                        const isAdded = added.some(r => r.id === rowId);
                        if (!isAdded) {
                          const alreadyChanged = changed.some(r => r.id === rowId);
                          if (!alreadyChanged) {
                            changed.push({ ...this.data });
                            editModule.batchChanges.changedRecords = changed; 
                          }
                        }
                      }
                    } catch (setErr) {
                      // Non-fatal; ignore if internal API signature changes
                    }

                    // Mark parent component dirty so navigation guards & external logic recognize pending changes
                    parent.isDirty = true;
                    parent.isPreventNavigation = true;
                    parent.$emit('update:isChangePrevent', true);

                    // Explicitly enable Update / Cancel toolbar buttons if template editing didn't auto-enable
                    try {
                      if (grid.toolbarModule && grid.element && grid.element.id) {
                        const baseId = grid.element.id;
                        const updateId = baseId + '_update';
                        const cancelId = baseId + '_cancel';
                        grid.toolbarModule.enableItems([updateId, cancelId], true);
                      }
                    } catch (toolbarErr) {
                      // Ignore toolbar enabling failures
                    }
                  } catch (err) {
                    // Silent catch to avoid breaking UX
                  }
                },
                generateRandomColor() {
                  const letters = '0123456789ABCDEF';
                  let color = '#';
                  for (let i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                  }
                  return color;
                },
              },
            },
          };
        };
      },

    };
  },

  computed: {
    ...mapGetters({
      tenantSettingConfig: "tenant/tenantSettingConfig",
      tenantSettingTypes: "tenant/tenantSettingTypes",
      masterSettingTypes: "tenant/masterSettingTypes",
    }),
    LoaderText() {
      return this.$t("LoaderText");
    },
    tenantId() {
      return localStorage.getItem("tenantId");
    },
    meetingTypeStorageKey() {
      return "meetingType#" + this.tenantId;
    },
    confirmDeleteRef() {
      return this.$refs;
    },
    meetingType() {
      return localStorage.getItem(this.meetingTypeStorageKey);
    },
    locale() {
      return this.$i18n.locale;
    },
    langDeleteLable() {
      return this.locale !== "ja" ? "Delete" : "削除";
    },
    gridObj() {
      if (this.$refs.SO_lineItem_Grid) {
        return this.$refs.SO_lineItem_Grid;
      } else {
        return null;
      }
    },
    gridInstance() {
      if (
        this.$refs.SO_lineItem_Grid &&
        this.$refs.SO_lineItem_Grid.ej2Instances
      ) {
        return this.$refs.SO_lineItem_Grid.ej2Instances;
      } else {
        return null;
      }
    },
    computedColumns() {
      let cols = [];
      let column = {
        field: "id",
        headerText: "#",
        isPrimaryKey: true,
        isIdentity: true,
        width: "0",
      };
      cols.push(column);

      if (this.setting && this.setting.columns) {
        this.setting.columns.forEach((col) => {
          let column = {
            field: col.value,
            headerText: this.$t(`admin.${col.label}`),
            template: this.columnTemplate(),
          };

          if (col.value == "color" && this.setting.configname === "meetingType") {
            column = {
              ...column,
              ...{
                editTemplate: this.colorEditTemplate(),
              },
            };
          } else if (col.type == "text") {
            column = {
              ...column,
              ...{
                validationRules: this.genericRequiredRules,
                editType: "textedit",
                editTemplate: this.columnEditTemplate(),
                dataValidate: "required,unique",
                maxlength: TITLE_LENGTH_150,
              },
            };
          } else if (col.type == "number") {
            column = {
              ...column,
              ...{
                validationRules:
                  col.value === "order"
                    ? this.numberRulesWithUnique
                    : this.numberRules,
                editType: "numericedit",
                edit: this.numericParams,
                textAlign: "center",
                format: "N",
              },
            };
          } else if (col.type == "boolean") {
            column = {
              ...column,
              ...{ type: "boolean", editTemplate: this.booleanEditTemplate() },
            };
          }
          cols.push(column);
        });

        let column = {
          field: "action",
          headerText: this.$t("admin.delete"),
          textAlign: "center",
          commands: [
            {
              type: "Delete",
              buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" },
            },
            {
              type: "Cancel",
              buttonOption: {
                cssClass: "e-flat",
                iconCss: "e-cancel-icon e-icons",
              },
            },
          ],
        };
        cols.push(column);
      }
      return cols;
    },

  },
  async created() {
    try {
      this.Loaderloading = true;
      this.configurations = await this.masterSettingTypes("settings");
      this.Loaderloading = false;
    } catch (error) {
      this.Loaderloading = false;
    }
  },
  mounted() {
    this.emitInterface();
    this.setConfig();

  },
  beforeDestroy() { },
  methods: {
    ...mapActions({
      updateTenantConfig: "tenant/updateTenantConfig",
      getMasterConfigList: "tenant/getMasterConfigList",
      setMeetingType: "meeting/setMeetingType",
    }),
    emitInterface() {
      this.$emit("interface", {
        saveConfig: () => this.saveDetails(),
        closeEdit: () => this.closeEditRef(),
        endEdit: () => this.endEditRef(),
      });
    },
    ...mapMutations({
      setSwitchTenantId: "setSwitchTenantId",
    }),
    
    generateRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    generateUniqueRandomColor() {
      const letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    endEditRef() {
      if (this.gridObj?.endEdit) {
        this.gridObj.endEdit();
      }
    },
    closeEditRef() {
      if (this.gridObj?.closeEdit) {
        this.gridObj.closeEdit();
      }
    },
    queryCellInfo(args) {
      if (args.column.field === "action") {
        if (args.data.isUsed) {
          const selector = `button[title='${this.langDeleteLable}']`;
          const element = args.cell.querySelector(selector);
          if (element !== undefined) {
            element.ej2_instances[0].disabled = true;
            element.classList.add("e-disabled");
            element.title = "";
          }
        }
      }
    },
    numberUniqueFn: function (args) {
      const rowData = this.gridInstance;
      const id = args.element.closest("tr").firstChild
        ? args.element.closest("tr").firstChild.innerHTML
        : "";
      args.element.setAttribute("data-required-message", "");
      if (args.value) {
        let found = false;
        for (const col of rowData.contentModule.rows) {
          const eName = col.changes
            ? col.changes[args.element.name]
            : col.data[args.element.name];
          const inputVal = args.value
            ? String(args.value).trim().toLowerCase()
            : args.value;
          const eNameVal = eName ? String(eName).trim().toLowerCase() : eName;
          if (eNameVal === inputVal && col.data.id != id) {
            found = true;
            break;
          }
        }
        if (found) {
          args.element.setAttribute(
            "data-required-message",
            this.$t("admin.msgFieldUnique")
          );
        }
        return !found;
      } else if (args.value == "") {
        return false;
      }
      return true;
    },
    colorUniqueValidationFn: function (args) {
      
      const rowData = this.gridInstance;
      args.element.setAttribute("data-required-message", "");
      
      let id = args.element.getAttribute("data-id");
      if (!id) {
        const row = args.element.closest("tr");
        if (row && row.firstChild) {
          id = row.firstChild.innerHTML;
        }
      }

      if (!args.value || args.value.trim() === '') {
        return true;
      }
      
      let found = false;
      const inputVal = String(args.value).trim().toLowerCase();
      
      for (const col of rowData.contentModule.rows) {
        const deletedRecord = col.edit && col.edit == "delete" ? "delete" : "";
        if (deletedRecord === "delete") {
          continue;
        }
        
        const eName = col.changes && col.changes.color !== undefined
          ? col.changes.color
          : col.data.color;
        
        const eNameVal = eName ? String(eName).trim().toLowerCase() : '';
        
        if (eNameVal === inputVal && col.data.id != id) {
          found = true;
          break;
        }
      }
      
      if (found) {
        return false;
      }
      
      return true;
    },
    uniqueValidationFn: function (args) {
      const rowData = this.gridInstance;
      args.element.setAttribute("data-required-message", "");
      const id = args.element.getAttribute("data-id");
      let found = false;
      for (const col of rowData.contentModule.rows) {
        const eName = col.changes
          ? col.changes[args.element.name]
          : col.data[args.element.name];
        const inputVal = args.value
          ? String(args.value).trim().toLowerCase()
          : args.value;
        const eNameVal = eName ? String(eName).trim().toLowerCase() : eName;
        if (eNameVal === inputVal && col.data.id != id) {
          found = true;
          break;
        }
      }
      if (found) {
        const fieldString = args.element.name ?? "";
        const fieldName =
          fieldString.charAt(0).toUpperCase() + fieldString.slice(1);
        args.element.setAttribute(
          "data-required-message",
          this.$t("admin.msgFieldUnique")
        );
        return false;
      }
      return true;
    },
    customValidationFn: function (args) {
      const rowData = this.gridInstance;
      const requiredMsg = args.element.getAttribute("data-required-message");
      args.element.setAttribute("data-required-message", "");
      const validationTypes = args.element.getAttribute("data-validate");
      if (validationTypes) {
        const validationTypeArr = validationTypes.split(",");
        if (
          validationTypeArr.includes("required") &&
          args.value.trim().length <= 0
        ) {
          args.element.setAttribute("data-required-message", requiredMsg);
          return false;
        }
        if (validationTypeArr.includes("unique")) {
          const id = args.element.getAttribute("data-id");
          let found = false;
          for (const col of rowData.contentModule.rows) {
            const deletedRecord =
              col.edit && col.edit == "delete" ? "delete" : "";

            const eName = col.changes
              ? col.changes[args.element.name]
              : col.data[args.element.name];
            const inputVal = args.value
              ? String(args.value).trim().toLowerCase()
              : args.value;
            const eNameVal = eName ? String(eName).trim().toLowerCase() : eName;
            if (
              eNameVal === inputVal &&
              col.data.id != id &&
              deletedRecord != "delete"
            ) {
              found = true;
              break;
            }
          }
          if (found) {
            const fieldString = args.element.name ?? "";
            const fieldName =
              fieldString.charAt(0).toUpperCase() + fieldString.slice(1);
            args.element.setAttribute(
              "data-required-message",
              this.$t("admin.msgFieldUnique")
            );
            return false;
          }
        }
      }
      return true;
    },
    beforeBatchAdd(args) {
      args.defaultData.id = createUUID();
      const isOrder = this.setting.columns.findIndex((x) => x.value == "order");
      const isColor = this.setting.columns.findIndex((c) => c.value == "color");
      const isValue = this.setting.columns.findIndex((v) => v.value == "value");

      if (isColor !== -1 && this.setting.configname === "meetingType") {
        args.defaultData.color = this.generateUniqueRandomColor();
      }

      if (isOrder !== -1) {
        args.defaultData.order = "";
      }
      if (isValue !== -1 && this.setting.configname !== "skills") {
        args.defaultData.value = null;
      }
    },
    beforeBatchSave(args) {
      this.gridObj.showSpinner();
    },
    cellSave(state) {
      if (state.name === "cellSave") {
        this.isDirty = true;
        this.isPreventNavigation = true;
        this.$emit("update:isChangePrevent", true);
      }
    },
    cellEdit(args) {
      if (args.type === "edit") {
        if (args.rowData.isUsed && args.columnName === "name") {
          args.cancel = true;
        }
      }
    },
    commandClick,
    toolbarClick,
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    async setConfig() {
      const config = this.setting;
      if (!this.isDirty) {
        await this.onTenantConfigNameChange(config);
      } else {
        this.$emit("update:isOpenPrevent", true);
      }
    },
    async saveDetails() {
      if (this.gridObj?.endEdit) {
        this.gridObj.endEdit();
      }
      this.isPrevent = false;
      const dataValid =
        this.gridInstance &&
          this.gridInstance.editModule &&
          this.gridInstance.editModule.formObj
          ? this.gridInstance.editModule.formObj.validate()
          : true;
      if (!dataValid) {
        this.isDirty = true;
        this.isPrevent = true;
        this.$emit("update:isOpenPrevent", true);
        this.$emit("update:isChangePrevent", true);
      }
    },
    async onTenantConfigNameChange(config) {
      try {
        const results = this.tenantSettingTypes(config.configname);
        const configUsedData =
          await tenantConfigService.getValidateTenantConfigList(
            config.configname
          );
        const data = results.map((item) => {
          let itemData = {
            ...item,
            id: item.id ? item.id : createUUID(),
            isUsed: configUsedData[item.name || item.label || item.value],
          };

          if (config.configname === "meetingType" && (!item.color || item.color === undefined)) {
            itemData.color = DEFAULT_MEETING_TYPE_COLOR;
          }

          if (config.configname === "skills" && (!item.value || item.value === null)) {
            itemData.value = item.name || "";
          }

          return itemData;

        });
        const _this = this;
        setTimeout(function () {
          _this.data = data;
        }, 100);

        if (this.gridObj) {
          this.gridObj.closeEdit();
          this.gridObj.refresh();
        }
        this.Loaderloading = false;
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    beforeDataBound: function (args) {
      this.loaderStart();
    },
    actionBegin(args) {
      this.loaderStart();
    },
    dataBound() {
      this.loaderStop();
    },
    loadSoGrid(args) {
      this.SO_lineItem_Grid_Loaded = true;
      this.gridInstance.defaultLocale.EmptyRecord = "";
    },
    actionComplete: async function (e) {
      if (e.requestType === "batchsave") {
        this.gridObj.showSpinner();
        const rows = e.rows.map((row) => row.data);
        const items = rows.map(({ isUsed, ...item }) => {
          if (this.setting.configname === 'skills' && (!item.value || item.value === null)) {
            item.value = item.name || "";
          }
          if (item.action) {
            delete item["action"];
          }
          
          const allowedKeys = {
            'category': ['id', 'is_displayed_on_annual_plan', 'name', 'order'],
            'meetingType': ['id', 'color', 'label'],
            'topiccategory': ['id', 'name', 'isapprovalrequired', 'order'],
            'skills': ['id', 'name', 'value']
          };
          
          const configAllowedKeys = allowedKeys[this.setting.configname];
          
          if (configAllowedKeys) {
            const filteredItem = {};
            configAllowedKeys.forEach(key => {
              if (item.hasOwnProperty(key)) {
                filteredItem[key] = item[key];
              }
            });
            
            if (!filteredItem.id) {
              filteredItem.id = createUUID();
            }
            
            return filteredItem;
          }
          
          return {
            ...item,
            id: item.id ? item.id : createUUID(),
          };
        });
        this.updateConfiguration(items);
        this.gridObj.hideSpinner();
      }
      await this.loaderStop();
    },
    async updateConfiguration(configData) {
      try {
        const tenantConfig = this.tenantSettingConfig(this.setting.configname);
        if (tenantConfig && tenantConfig.id) {
          let processedData = configData;

          if (this.setting.configname === "skills") {
            processedData = configData.map(item => {
              if (item.value === null || item.value === undefined || item.value === "") {
                return {
                  ...item,
                  value: item.name || ""
                };
              }
              return item;
            });
          }


          const setting = {
            id: tenantConfig.id,
            tenantid: tenantConfig.tenantid,
            configname: tenantConfig.configname,
            [this.setting.configname]: processedData, 
          };

          this.Loaderloading = true;
          await this.updateTenantConfig(setting);

          if (this.setting.configname === "meetingType") {
            this.$root.$emit('meetingTypeColorsUpdated');
          }

          if (this.isOpenPrevent) {
            this.$emit("discard");
          }
          this.$emit("update:isOpenPrevent", false);
          this.isPreventNavigation = false;
          this.isDirty = false;
          this.$emit("update:isChangePrevent", false);
          this.Loaderloading = false;
          this.displayMessage = true;
          this.messageType = "success";
          this.message = this.$t("admin.updateTenantConfigMsg");
          this.$emit("switchConfig", true);
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },

    async sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    loaderStart() {
      this.Loaderloading = true;
      if (this.gridObj && this.gridObj.$el.classList) {
        this.gridObj.$el.classList.add("disablegrid");
        let gridElement = document.getElementById("GridParent");
        if (gridElement?.classList) {
          gridElement.classList.add("wrapper");
        }
      }
    },
    async loaderStop() {
      await this.sleep(2000);
      if (
        this.gridObj &&
        this.gridObj.$el.classList &&
        this.gridObj.$el.classList.contains("disablegrid")
      ) {
        this.gridObj.$el.classList.remove("disablegrid");
        let gridElement = document.getElementById("GridParent");
        if (gridElement?.classList) {
          gridElement.classList.remove("wrapper");
        }
      }
      this.Loaderloading = false;
    },
  },
};
async function toolbarClick(args) {
  const dataValid =
    this.gridInstance &&
      this.gridInstance.editModule &&
      this.gridInstance.editModule.formObj
      ? this.gridInstance.editModule.formObj.validate()
      : true;
  if (
    (args.item.properties.text === "Update" ||
      args.item.properties.text === "Save" ||
      args.item.properties.text === "更新" ||
      args.item.properties.text === "保存" ||
      args.item.properties.text === "セーブ") &&
    dataValid
  ) {
    args.originalEvent.stopPropagation();
    args.cancel = true;
    if (
      await this.$refs.confirm.open(
        this.$t("admin.hUpdateMessage"),
        this.$t("admin.msgUpdateSetting"),
        { yesNoButtons: true }
      )
    ) {
      this.gridObj.endEdit();
      args.cancel = false;
    }
  } else if (
    args.item.properties.text === "Cancel" ||
    args.item.properties.text === "キャンセル"
  ) {
    this.$emit("update:isOpenPrevent", false);
    this.isPreventNavigation = false;
    this.isDirty = false;
    this.$emit("update:isChangePrevent", false);
  }
}

async function commandClick(args) {
  let selectedrowindex = this.gridInstance.getRowInfo(args.target);
  const dataValid =
    this.gridInstance &&
      this.gridInstance.editModule &&
      this.gridInstance.editModule.formObj
      ? this.gridInstance.editModule.formObj.validate()
      : true;

  if (args.commandColumn.type === "Delete") {
    args.cancel = true;
    if (!args.rowData.isUsed) {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.lblDeleteMessage")
        )
      ) {
        if (
          selectedrowindex.cell &&
          !selectedrowindex.cell.classList.contains("e-active")
        ) {
          this.gridInstance.selectRow(selectedrowindex.rowIndex, true);
        }
        this.gridObj.deleteRecord(selectedrowindex.target);
        this.gridObj.clearRowSelection();
        const toolbarItems = document.getElementsByClassName("e-toolbar-item");
        args.cancel = false;
        for (const item of toolbarItems) {
          const title = item.getAttribute("title")
            ? item.getAttribute("title")
            : "";
          const disabled = item.getAttribute("aria-disabled")
            ? item.getAttribute("aria-disabled")
            : "";
          if (
            item &&
            disabled === "false" &&
            (title.trim() === "Cancel" || title.trim() === "キャンセル")
          ) {
            this.isDirty = true;
            this.isPreventNavigation = true;
            this.$emit("update:isChangePrevent", true);
          } else if (
            item &&
            disabled === "true" &&
            (title.trim() === "Cancel" || title.trim() === "キャンセル")
          ) {
            this.$emit("update:isOpenPrevent", false);
            this.isPreventNavigation = false;
            this.isDirty = false;
            this.$emit("update:isChangePrevent", false);
          }
        }
      }
    }
  } else if (args.commandColumn.type === "Delete" && !dataValid) {
    args.cancel = true;
  }
}
</script>

<style scoped>
.item-active-class {
  background: #006cad !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

::v-deep .e-grid .e-tooltip-wrap.e-griderror {
  z-index: 10 !important;
}

::v-deep .e-grid .e-gridheader {
  background-color: var(--v-appBar-darken1);
  border-bottom-color: #e0e0e0;
  border-top-color: #e0e0e0;
  color: rgba(0, 0, 0, 0.54);
}

::v-deep .e-grid .e-rowcell {
  padding-right: 8px !important;
}

::v-deep .e-grid .e-headercell,
.e-grid .e-detailheadercell {
  /* color: var(--v-secondary-darken1);
  background-color: var(--v-appBar-darken1);
  border-bottom: 2px solid var(--v-appBar-darken2) !important;
  height: 32px !important; */
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  background: var(--v-neutralGray-base) !important;
  color: #ffffff !important;
  height: 32px !important;
  min-height: 32px !important;
}

::v-deep .e-grid .e-headercelldiv {
  font-weight: bold;
  font-size: 12px;
}

::v-deep .e-gridcontent {
  height: 410px !important;
}

::v-deep .e-gridcontent .e-content {
  height: 410px !important;
}

::v-deep .e-toolbar.e-control {
  box-sizing: content-box;
  background-color: var(--v-appBar-base) !important;
  border-color: var(--v-pageHeader-base) !important;
  color: #ffffff;
  display: grid !important;
}

::v-deep .v-card__text {
  width: 100%;
  padding: 12px !important;
}

::v-deep .e-grid .e-toolbar-items {
  /* background-color: inherit; */
  height: 48px !important;
  min-height: 48px !important;
}

.e-grid .e-toolbar-items {
  background-color: #fff;
}

::v-deep .e-toolbar .e-toolbar-items .e-toolbar-item {
  align-content: center;
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  min-height: 40px !important;
  vertical-align: middle;
  width: auto;
}

::v-deep .e-toolbar .e-tbar-btn.e-btn {
  font-family: "Noto Sans JP" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  background-color: var(--v-primaryDark-base) !important;
  border-color: var(--v-primaryDark-base) !important;
  min-width: 64px !important;
  padding: 0 16px 0 10px !important;
  color: #fff !important;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

::v-deep .e-toolbar .e-tbar-btn.e-btn .e-icons {
  color: #fff;
}

::v-deep .e-toolbar .e-overlay[aria-disabled="true"] .e-tbar-btn.e-btn {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

::v-deep .e-toolbar .e-overlay[aria-disabled="true"] .e-icons,
::v-deep .e-toolbar .e-overlay[aria-disabled="true"] .e-tbar-btn-text {
  color: rgba(0, 0, 0, 2.26) !important;
}

::v-deep .e-toolbar .e-toolbar-items .e-toolbar-item .e-tbar-btn-text {
  color: #fff;
}

::v-deep .e-toolbar .e-toolbar-items .e-toolbar-item.e-overlay {
  background: inherit;
}

::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal {
  background: var(--v-pageHeader-lighten2);
  z-index: 1 !important;
  width: 1px !important;
  margin-left: 1px;
  margin-right: 1px;
}

.splitterContent /deep/ .e-split-bar.e-split-bar-horizontal.e-resizable-split-bar::after {
  width: 4px !important;
}

/* split bar color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active {
  background: var(--v-pageHeader-base);
}

/* default split bar resize handle color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* default split bar resize handle color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover .e-resize-handler,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active .e-resize-handler {
  color: var(--v-pageHeader-base);
}

/* split bar arrows - circular border */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover .e-navigate-arrow.e-arrow-left {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}

::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten2) !important;
  opacity: initial;
}

/* split bar arrows */

::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-navigate-arrow.e-arrow-right {
  background-color: var(--v-pageHeader-lighten3) !important;
  opacity: 0.2;
}
</style>